import { BoxButton, Dialog, DialogContent, DialogFooter, DialogTitle } from '@repo/ui';
import { ReactNode } from 'react';

interface Props {
  isOpen: boolean;

  title: string;
  message: ReactNode;
  primaryButtonText: string;
  secondaryButtonText?: string;

  handleClickPrimaryButton: () => void;
  handleClickSecondaryButton?: () => void;
}

const JointCertificateSelectErrorDialog = ({
  isOpen,
  title,
  message,
  primaryButtonText,
  secondaryButtonText,
  handleClickPrimaryButton,
  handleClickSecondaryButton
}: Props) => {
  const onClickPrimaryButton = () => {
    handleClickPrimaryButton();
  };

  const onClickSecondaryButton = () => {
    if (handleClickSecondaryButton) {
      handleClickSecondaryButton();
    }
  };

  return (
    <Dialog open={isOpen}>
      <DialogContent>
        <DialogTitle title={title} description={message} />
        <DialogFooter className="flex gap-normal-small p-normal-medium !pt-2">
          {secondaryButtonText ? (
            <BoxButton className="flex-1" variant="tonal-secondary" size="medium" onClick={onClickSecondaryButton}>
              {secondaryButtonText}
            </BoxButton>
          ) : null}
          <BoxButton className="flex-1" variant="filled-primary" size="medium" onClick={onClickPrimaryButton}>
            {primaryButtonText}
          </BoxButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default JointCertificateSelectErrorDialog;
